"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.colorPickerDisplayFormats = void 0;
exports.colorPickerDisplayFormats = ["hex", "rgb", "cmyk"];
